import { render, staticRenderFns } from "./input-search-dropdown.vue?vue&type=template&id=189d4c4a&scoped=true&"
import script from "./input-search-dropdown.vue?vue&type=script&lang=js&"
export * from "./input-search-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./input-search-dropdown.vue?vue&type=style&index=0&id=189d4c4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189d4c4a",
  null
  
)

export default component.exports